"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonitorHelper = void 0;
class MonitorHelper {
    // ---------------------------------------------------------------------------
    static async getWindowMonitor(window) {
        if (window.desktopOnly) {
            return MonitorHelper.getWindowDesktopMonitor(window.windowInfo.monitorId);
        }
        return new Promise(async (resolve) => {
            overwolf.games.getRunningGameInfo2(async (res) => {
                var _a;
                if (!(res === null || res === void 0 ? void 0 : res.success) || !((_a = res === null || res === void 0 ? void 0 : res.gameInfo) === null || _a === void 0 ? void 0 : _a.isInFocus)) {
                    resolve(await MonitorHelper.getWindowDesktopMonitor(window.windowInfo.monitorId));
                    return;
                }
                const info = res.gameInfo;
                const monitor = {
                    width: info.logicalWidth,
                    height: info.logicalHeight,
                    left: 0,
                    top: 0,
                };
                resolve(monitor);
            });
        });
    }
    // ---------------------------------------------------------------------------
    static async getWindowDesktopMonitor(monitorId) {
        return new Promise(async (resolve, reject) => {
            overwolf.utils.getMonitorsList(async (monRes) => {
                var _a;
                const mon = (_a = monRes === null || monRes === void 0 ? void 0 : monRes.displays) === null || _a === void 0 ? void 0 : _a.find(mon => mon.id === monitorId);
                if (!monRes.success || !mon) {
                    reject('Failed to find monitor');
                    return;
                }
                const monitor = {
                    width: mon.workingArea.width,
                    height: mon.workingArea.height,
                    left: mon.workingArea.left,
                    top: mon.workingArea.top,
                };
                resolve(monitor);
            });
        });
    }
}
exports.MonitorHelper = MonitorHelper;
//# sourceMappingURL=monitor_helper.js.map